import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const UserIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      sx={{ fontSize: "inherit", ...sx, fill: "none" }}
      fill="none"
      className={clsx("qi-icon qi-icon-user", className)}
      {...otherProps}
    >
      <path
        d="M10.0001 9.78516C12.2534 9.78516 13.9584 7.75516 13.9584 5.41016C13.9584 3.06515 12.2534 1.03516 10.0001 1.03516C7.74678 1.03516 6.04175 3.06515 6.04175 5.41016C6.04175 7.75516 7.74678 9.78516 10.0001 9.78516Z"
        stroke="currentColor"
        strokeWidth="1.25"
      ></path>
      <path
        d="M2.5 17.6125C2.5 14.3251 5.16497 11.6602 8.45238 11.6602H11.5476C14.835 11.6602 17.5 14.3251 17.5 17.6125V17.6125C17.5 18.007 17.1802 18.3268 16.7857 18.3268H3.21429C2.8198 18.3268 2.5 18.007 2.5 17.6125V17.6125Z"
        stroke="currentColor"
        strokeWidth="1.25"
      ></path>
    </SvgIcon>
  );
};

export default memo(UserIcon);
